import React from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';

/**
 * FooterItem is a small wrapper for a single footer element (link, action, or text).
 *
 * Why this exists:
 * - Normalizes per-item height and vertical alignment across mixed content types.
 * - Avoids repeated inline item wrappers in Footer composition.
 *
 * Use this when:
 * - You place one logical unit inside a FooterColumn.
 * - You want consistent item rhythm without custom wrappers.
 *
 * Typical usage:
 * <FooterItem><FooterLink ... /></FooterItem>
 */
function FooterItem({ children }) {
	return (
		<Stack
			direction="row"
			alignItems="center"
			sx={{
				height: '1.45rem',
				maxHeight: '100%',
			}}
		>
			{children}
		</Stack>
	);
}

FooterItem.propTypes = {
	children: PropTypes.node,
};

export default FooterItem;
